import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { ContentAuthoringService } from "../../services/content-authoring.service";
import { NgxSpinnerService } from "ngx-spinner";
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { updateLanguageServiceSourceFile } from 'typescript';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.scss']
})
export class UserEditComponent implements OnInit {

  private BASE_URL: string = environment.BASEURL;
  private BASE_LINK: string = environment.BASELINK;
  submitted = false;
  errorInfo: { isError: boolean, errorMsg: string } = { isError: false, errorMsg: '' }
  data = {}; userData = ""; closeResult: any = '';
  is_active = '1';
  organisationData: any;
  userID: any;
  adminData: any; order_by: any = 'created_dttm'; order: any = 'ASC';
  emailError: string = '';
  phoneError: string = '';
  userDetail: any;
  content: any = 'update';
  imageSrc: any = null;
  changePhoto: any = '';
  img: any = '';

  constructor(private contentAuthoringApi: ContentAuthoringService,
    private route: ActivatedRoute,
    private router: Router, private spinner: NgxSpinnerService, private modalService: NgbModal) {
    if (localStorage.getItem('adminData') == '' || localStorage.getItem('adminData') == null) {
      this.router.navigateByUrl('/admin-login');
    }
  }
  userForm = new FormGroup({
    first_name: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z-. ]*$")]),
    last_name: new FormControl('', [Validators.pattern("^[a-zA-Z-. ]*$")]),
    email: new FormControl('', [Validators.required, Validators.email,
    Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
    phone: new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(10), Validators.maxLength(10)]),
    organisation_id: new FormControl('', [Validators.required]),
    created_by: new FormControl('2'),
    change_pass_link: new FormControl(this.BASE_LINK + '/#/create_password'),
    //change_pass_link:new FormControl(this.BASE_LINK+'/create_password'),
    // change_pass_link:new FormControl('http://rail-elearning.com/#/create_password'),
    //organisation_id: new FormControl('', Validators.required),
    user_type: new FormControl(1),
    user_image: new FormControl(null),
  });
  get f() { return this.userForm.controls; }

  ngOnInit(): void {
    this.getOrganisationList(this.is_active);
    this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
    this.route.queryParams.subscribe(params => {
      const id = +params.id;
      if (id > 0) {
        console.log(id);
        this.userID = id;
        this.getUserDetail(this.userID);
        this.userForm.controls.email.disable();
      }
    });
  }

  open(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  getOrganisationList(is_active: any) {
    this.contentAuthoringApi.getOrganisationList("", is_active, this.order_by, this.order).subscribe(
      (data) => {
        console.log(data);
        if (data.success) {
          this.organisationData = data.organisationList;
        } else {
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'No data Exist';
        }
      },
      (error) => {
        this.errorInfo.errorMsg = error;
      },
    );
  }

  /*get user lidting data********/
  getUserDetail(userID: any) {
    this.spinner.show();
    this.contentAuthoringApi.getUserDetail(userID).subscribe(
      (data) => {
        // console.log(data,'hello');
        this.userDetail = data.userList;
        if (data.success) {
          this.spinner.hide();
          this.imageSrc = data.userList.user_image;
          this.userForm.patchValue({
            user_image: data.userList.user_image,
            first_name: data.userList.first_name,
            last_name: data.userList.last_name,
            phone: data.userList.phone,
            email: data.userList.email,
            organisation_id: data.userList.organisation_id,
            // created_by:data.userList.first_name,
          });

        } else {
          this.spinner.hide();
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );
  }


  /*******create customer user (normal user)******/
  editUser(userForm: any) {
    this.spinner.show();
    this.submitted = true;
    if (this.userForm.value.phone.length != 10 && this.userForm.value.phone.length != 0) {
      this.phoneError = 'Please input valid phone number';
    } else { this.phoneError = ''; }
    if (this.userForm.invalid) { this.spinner.hide(); return; }
    this.contentAuthoringApi.editUser(this.userForm.getRawValue()).subscribe(
      (data) => {
        this.emailError = ''; this.phoneError = '';
        // console.log(data);return false;
        if (data.status == 201 || data.status == 200) {
          this.spinner.hide();
          document.getElementById('successMsg')?.click();
          this.router.navigateByUrl('/user');
        }
        else if (data.email_error || data.phone_error) {
          this.spinner.hide();
          this.errorInfo.isError = true;
          this.emailError = data.email_error;
          this.phoneError = data.phone_error;
        } else {
          this.spinner.hide();
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'Something went wrong';
        }
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );
  }

  logout() {
    //localStorage.clear();
    localStorage.removeItem('adminLoginPass');
    localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
  }
  onFileChange(event: any) {
    this.img = '';
    this.changePhoto = event.target.files.item(0);
    var mimeType = this.changePhoto.type;
    if (mimeType.match(/image\/(png|jpeg|jpg)/) == null) {
      alert('Only png , jpeg , jpg file supported only');
      return;
    }
    if (this.changePhoto.size / 1024 > 1024) {
      alert('The maximum supported file sizes 1 MB ');
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(this.changePhoto);
    reader.onload = (_event) => {
      const img = new Image();
      img.src = reader.result as string;
      img.onload = (_event) => {
        const height = img.naturalHeight;
        const width = img.naturalWidth;
        console.log('Width and Height', width, height);
        if ((height < 70 || height > 120) || (width < 70 || width > 120)) {
          alert('Height and Width must  70*70 to 120*120.');
          return;
        }

        this.imageSrc = reader.result;
        this.userForm.patchValue({ user_image: this.imageSrc });
      };
    }
  }
}
